import { createActions } from 'reduxsauce'

const { Types, Creators } = createActions({
  fetchOverview: ['filter'],
  fetchOverviewLoading: null,
  fetchOverviewSuccess: ['data'],
  fetchOverviewFail: ['error'],

  fetchAverageDuration: ['filter'],
  fetchAverageDurationLoading: null,
  fetchAverageDurationSuccess: ['data'],
  fetchAverageDurationFail: ['error'],

  fetchTransactionsStatistics: null,
  fetchTransactionsStatisticsLoading: null,
  fetchTransactionsStatisticsSuccess: ['data'],
  fetchTransactionsStatisticsFail: ['error'],

  fetchConnectorsStatus: null,
  fetchConnectorsStatusLoading: null,
  fetchConnectorsStatusSuccess: ['data'],
  fetchConnectorsStatusFail: ['error'],

  fetchPeakHour: ['filter'],
  fetchPeakHourLoading: null,
  fetchPeakHourSuccess: ['data'],
  fetchPeakHourFail: ['error'],

  fetchTopSites: ['filter'],
  fetchTopSitesLoading: null,
  fetchTopSitesSuccess: ['data'],
  fetchTopSitesFail: ['error'],

  fetchTokensStatistics: ['filter'],
  fetchTokensStatisticsLoading: null,
  fetchTokensStatisticsSuccess: ['data'],
  fetchTokensStatisticsFail: ['error'],

  fetchRevenueTrend: ['filter'],
  fetchRevenueTrendLoading: null,
  fetchRevenueTrendSuccess: ['data'],
  fetchRevenueTrendFail: ['error'],

  fetchTokensActivity: null,
  fetchTokensActivityLoading: null,
  fetchTokensActivitySuccess: ['data'],
  fetchTokensActivityFail: ['error'],

  fetchTopCities: ['filter'],
  fetchTopCitiesLoading: null,
  fetchTopCitiesSuccess: ['data'],
  fetchTopCitiesFail: ['error'],
})

export const AnalyticsTypes = Types
export default Creators
